import { render, staticRenderFns } from "./priceBuyBtn.vue?vue&type=template&id=62abe18e&scoped=true"
import script from "./priceBuyBtn.vue?vue&type=script&lang=js"
export * from "./priceBuyBtn.vue?vue&type=script&lang=js"
import style0 from "./priceBuyBtn.vue?vue&type=style&index=0&id=62abe18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62abe18e",
  null
  
)

export default component.exports